import { Component } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { filter } from 'rxjs/operators';
import { ReusableStreamProperty } from '@ipreo/muni-shared';
import { GameDayModel } from '../../../models/gameday-model';
import { getGamedayDealState } from '../../../state/data/reducer';
import { GameDayRootReducerState } from '../../../state/root.state';

@Component({
  selector: 'muni-gameday-countdown',
  templateUrl: './countdown.template.html',
  styleUrls: ['./countdown.styles.scss']
})
export class CountdownComponent {
  @ReusableStreamProperty
  public readonly deal$: Observable<GameDayModel.Deal> = this.store.pipe(
    select(getGamedayDealState),
    filter(deal => !!deal)
  );

  constructor(private readonly store: Store<GameDayRootReducerState>) {}
}
